import { useQuery } from '@tanstack/react-query';
import {
  fetchHouseInventory,
  type HouseInventoryQuery,
} from '@/services/api/houseInventory.api';

export function useHouseInventory(query: HouseInventoryQuery, enabled = true) {
  return useQuery({
    queryKey: ['house-inventory', query],
    queryFn: () => fetchHouseInventory(query),
    staleTime: 30_000,
    enabled: enabled && !!query.propertyId && !!query.from && !!query.to,
  });
}
